import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LITERALS } from 'src/app/core/constants/literals.constant';
import { REGEX_PATTERNS } from 'src/app/core/constants/regex-patterns.constant';
import { AuthService } from 'src/app/core/services/auth.service';
import { LoggedLandingPageService } from 'src/app/core/services/logged-landing-page.service';
import { ProfileService } from 'src/app/core/services/profile.service';
import { WalletService } from 'src/app/core/services/wallet.service';
import { environment } from 'src/environments/environment';
import { ErrorMessageComponent } from '../../all-modals/error-message/error-message.component';
import { AddTokensComponent } from '../add-tokens/add-tokens.component';
import { EnterMobileComponent } from '../enter-mobile/enter-mobile.component';
import { EnterOtpComponent } from '../enter-otp/enter-otp.component';

@Component({
  selector: 'app-transfer-tokens',
  templateUrl: './transfer-tokens.component.html',
  styleUrls: ['./transfer-tokens.component.scss']
})
export class TransferTokensComponent implements OnInit, OnDestroy {
  transferTokenForm: FormGroup;
  userTokens: number = 0;
  remainingTokens: number = 0;
  tokenValueInUSD = 0;
  tokenRate = 10;
  connections: any;
  isLoading: boolean = false;
  selectedUserImage = 'assets/images/modals/default-user-profile-image.png';
  imagePath = environment.url;
  modalDivHidden = false;
  submitted: boolean = false;
  private ngUnsubscribe = new Subject();
  isUserTransferableError = false;
  dropdownConnection = {
    singleSelection: true,
    // selectAllText: 'Select All',
    // unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    enableFilterSelectAll: false,
    classes: "myclass custom-class form-control",
    text: 'Please select connection',
    noDataLabel: "No connections found",
    labelKey: "name",
    searchBy: ['name']
  };
  isSuppError = '';
  @Input() public open;
  isSupplementary: boolean;
  isSuppDisableParent: boolean = false;
  currentUser;
  constructor(private activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private _walletService: WalletService,
    private _profileService: ProfileService,
    private _loggedLandingPageService: LoggedLandingPageService,
    private modalService: NgbModal,
    private _authService: AuthService
  ) { }

  ngOnInit() {
    this.currentUser = this._authService.getCurrentUser();
    this.isSupplementary = this._authService.isSupplementaryAccount();
    this.transferTokenForm = this.formBuilder.group({
      user_id: ['', Validators.required],
      user: [''],
      email: [null],
      // email: [null, Validators.compose([Validators.required, Validators.pattern(REGEX_PATTERNS.EMAIL_PATTERN)])],
      tokens: [null, Validators.compose([Validators.required, Validators.pattern(REGEX_PATTERNS.INTEGER_PATTERN), Validators.min(1)])]
    });
    this.loadTokens();
    this.loadConnections();
    this.initTokenConverter();
    this._loggedLandingPageService.convertToken(1).pipe(takeUntil(this.ngUnsubscribe)).subscribe((response) => { if (response.success) { this.tokenRate = response.data.converted_amount } });
    if (this.open == 'transfer' && sessionStorage.getItem('transferTokenFormData')) {
      this.transferTokenForm.setValue(JSON.parse(sessionStorage.getItem('transferTokenFormData')));
    }
    sessionStorage.removeItem('transferTokenFormData');
  }


  loadTokens() {
    // this.spinner.show();
    this._walletService.loadTokens().subscribe(
      (response: any) => {
        if (response.success) {
          // this.userTokens = parseInt(response.data.account.purchased_tokens) + parseInt(response.data.account.transferred_tokens);
          this.userTokens = parseInt(response.data.account.total_giftable_tokens);
          this.transferTokenForm.controls['tokens'].setValidators(Validators.compose([Validators.required, Validators.pattern(REGEX_PATTERNS.INTEGER_PATTERN), Validators.max(this.userTokens), Validators.min(1)]));
          this.remainingTokens = JSON.parse(JSON.stringify(this.userTokens));

          if (this.transferTokenForm.get('tokens').value) {
            this.remainingTokens = this.remainingTokens - this.transferTokenForm.get('tokens').value;
            this.transferTokenForm.controls['tokens'].updateValueAndValidity();
          }

        }
        else if (response.status == 422) {
          this.remainingTokens = 0;
        }

      }, (error: any) => {
        // this._toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
      });
  }

  initTokenConverter() {
    this.transferTokenForm.get('tokens').valueChanges.subscribe((val) => {
      if (this.tokenRate) {
        this.tokenValueInUSD = val / this.tokenRate;
      }

    })
    // following code can be used when there is multiple currency
    // this.transferTokenForm.get('tokens').valueChanges.pipe(
    //   startWith(0),
    //   debounceTime(250),
    //   distinctUntilChanged(),
    //   switchMap(val => {
    //     if(val){
    //       return this._loggedLandingPageService.convertToken(val);
    //     }else{
    //       this.tokenValueInUSD = 0;
    //     }
    //   }),
    //   takeUntil(this.ngUnsubscribe)
    // ).subscribe(
    //   (response: any) => {
    //     if (response.success) {
    //       this.tokenValueInUSD = (this.transferTokenForm.get('tokens').value * this.transferTokenForm.get('tokens').value) / response.data.converted_amount;
    //     }
    //   }, (error: any) => {

    //   });
  }

  getEmail(event) {
    this.isSuppError = '';
    this.isUserTransferableError = false;
    this.isSuppDisableParent = false;
    if (!event.transferable) {
      this.isUserTransferableError = event.name;
    }
    if (event && event.user.parent_user_id != this.currentUser.user.id && event.user.user_account_type == 'supplementary' && this.currentUser.user.user_account_type != 'supplementary') {
      this.isSuppError = LITERALS.AUTH.ERROR_MESSAGES.SUPP_TRANSFER_TOKEN_RESTRICT;
    }
    if (event && event.supplementary_user_disable_status && event.user.user_account_type == 'supplementary') {
      if (event.user.parent_user_id == this.currentUser.user.id) {
        this.isSuppError = 't';
        this.isSuppDisableParent = true;
      }
    }
    this.transferTokenForm.get('user').setValue([event]);
    if (event) {
      if (event.user.image) {
        this.selectedUserImage = this.imagePath + event.user.image;
      } else {
        this.selectedUserImage = 'assets/images/modals/default-user-profile-image.png';
      }
      this.transferTokenForm.get('email').setValue(event.user.email);
      this.transferTokenForm.get('user_id').setValue(event.user.id);
    }
    else {
      this.transferTokenForm.get('email').setValue('');
      this.transferTokenForm.get('user_id').setValue('');
      this.selectedUserImage = 'assets/images/modals/default-user-profile-image.png';
    }
  }

  OnUserDeselect(event) {
    this.isSuppError = '';
    this.isUserTransferableError = false;
    this.transferTokenForm.get('user').setValue('');
    this.selectedUserImage = 'assets/images/modals/default-user-profile-image.png';
    this.transferTokenForm.get('email').setValue('');
    this.transferTokenForm.get('user_id').setValue('');
  }

  loadConnections() {
    this._profileService.fetchConnections().subscribe(
      (response: any) => {
        if (response.success) {
          this.connections = response.data.connections;
          if (this.connections.length > 0) {
            this.connections.forEach(element => {
              if (element.user.name) {
                element.name = element.user.name;
              }
            });
            if (this.transferTokenForm.get('email').value) {
              this.checkEmail(this.transferTokenForm.get('email').value);
            }
          }
        }
        // this.spinner.hide();
        this.isLoading = false;
      }, (error: any) => {
        this.isLoading = false;
        this.spinner.hide();
        // this._toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
      });
  }

  checkEmail(value) {
    this.transferTokenForm.get('user').setValue('');
    this.selectedUserImage = 'assets/images/modals/default-user-profile-image.png';
    if (this.transferTokenForm.get('email').valid) {
      this.connections.forEach(connection => {
        if (connection.user.image) {
          connection.user.image = this.imagePath + connection.user.image;
        } else {
          connection.user.image = 'assets/images/modals/default-user-profile-image.png';
        }
        if (value.toLowerCase() === connection.user.email) {
          this.getEmail(connection);
          if (connection.user.image) {
            this.selectedUserImage = connection.user.image;
          } else {
            this.selectedUserImage = 'assets/images/modals/default-user-profile-image.png';
          }
          return true;
        }
      });
    }
  }

  setPlaceHolderForConnection(connection) {
    connection.user.image = 'assets/images/modals/default-user-profile-image.png';
  }

  checkTokens(event) {
    this.remainingTokens = JSON.parse(JSON.stringify(this.userTokens));
    this.remainingTokens = event.target.value ? this.remainingTokens - event.target.value : JSON.parse(JSON.stringify(this.userTokens));
  }

  /**
  * restrict e . + -
  *
  * @param {*} event
  * @returns
  * @memberof AddTokensComponent
  */
  restrictNumeric(event) {
    //firefox solution
    event = event || window.event;
    var charCode = (typeof event.which == "undefined") ? event.keyCode : event.which;
    var charStr = String.fromCharCode(charCode);

    if (!charStr.match(/^[0-9]+$/))
      event.preventDefault();
    const restrictKeycodes = [101, 46, 43, 45];
    if (restrictKeycodes.includes(event.keyCode) || event.target.value.length > 11) {
      return false;
    }
  }

  restrictNumericPaste(event) {
    let text = event.clipboardData.getData('text').toString();
    let filteredText = text.replace(REGEX_PATTERNS.NUMBER_REMOVE, "");

    this.transferTokenForm.patchValue({
      tokens: (this.transferTokenForm.get('tokens').value) ? (this.transferTokenForm.get('tokens').value.toString() + filteredText) : filteredText
    });

    event.preventDefault();
  }

  closeDialog() {
    this.activeModal.close();
  }

  addTokens() {
    sessionStorage.setItem('transferTokenFormData', JSON.stringify(this.transferTokenForm.value));
    this.closeDialog();
    this.openAddTokenModal();
  }

  openAddTokenModal() {
    const modalRef = this.modalService.open(AddTokensComponent, { size: 'lg', centered: true, windowClass: 'add-token' });
    modalRef.componentInstance.sourceGift = 'transfer';
    modalRef.componentInstance.inputTokens = this.transferTokenForm.get('tokens').value - this.userTokens;
  }
  onSubmit() {
    this.submitted = true;
    if (!this.transferTokenForm.valid || this.isUserTransferableError) {
      return;
    }
    const userData = this._authService.getCurrentUser();

    if (!userData.user.international_phone_number || userData.user.international_phone_number == "undefined") {
      const params = {
        user_id: this.transferTokenForm.get('user_id').value,
        tokens: this.transferTokenForm.get('tokens').value,
        'source': 'transferToken',
      };
      this.openMobileModal(params);
    } else {
      const params = {
        tokens: this.transferTokenForm.get('tokens').value,
        user_id: this.transferTokenForm.get('user_id').value,
        email: this.transferTokenForm.get('email').value,
        'source': 'transferTokenNoBack',
      };
      this.transferTpken(params, userData.user.international_phone_number);

    }
    // const params = {
    //   tokens: this.transferTokenForm.get('tokens').value,
    //   user_id: this.transferTokenForm.get('user_id').value,
    //   email: this.transferTokenForm.get('email').value
    // }
    // this._walletService.transferTokens(params).subscribe((response) => {
    //   if (response.success) {
    //     let account_transaction = response.data.account_transaction;
    //     account_transaction.transaction_flow = 'debit';
    //     account_transaction.closing_balance = response.data.account.total_tokens;
    //     this._walletService.setTransaction(account_transaction);
    //     this.activeModal.close('success');
    //     const modelref = this.modalService.open(SuccessMessageComponent, { centered: true });
    //     modelref.componentInstance.message = this.transferTokenForm.get('tokens').value + " tokens transferred successfully"
    //   } else {
    //     const modelref = this.modalService.open(ErrorMessageComponent, { centered: true });
    //     modelref.componentInstance.message = "Error occured during trasferring tokens";
    //   }
    // }, (reason) => {
    //   const modelref = this.modalService.open(ErrorMessageComponent, { centered: true });
    //   modelref.componentInstance.message = "Error occured during trasferring tokens"
    // });

  }
  openMobileModal(transferData) {
    // this.closeDialog();
    // this.modalDivHidden = true;
    document.body.classList.add("hide-mobile-modal");
    const modalRef = this.modalService.open(EnterMobileComponent, { centered: true, backdrop: false, scrollable: false });
    modalRef.componentInstance.giftUserData = transferData;
    modalRef.result.then((result) => {
      this.spinner.show();
      if (result === 'success') {
        // this.modalDivHidden = false;
        if (document.body.classList.contains('hide-mobile-modal')) {
          document.body.classList.remove("hide-mobile-modal");
        }
        const userData = this._authService.getCurrentUser();
        if (userData.user.international_phone_number || userData.user.international_phone_number !== "undefined") {
          const params = {
            tokens: this.transferTokenForm.get('tokens').value,
            user_id: this.transferTokenForm.get('user_id').value,
            email: this.transferTokenForm.get('email').value,
            'source': 'transferTokenNoBack',
          };
          this.transferTpken(params, userData.user.international_phone_number);
        } else {
          const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modalRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.GIFT_TOKEN_FAIL;
        }
      } else {
        this.activeModal.dismiss();
      }
    }, (reason) => {
      if (document.body.classList.contains('hide-mobile-modal')) {
        document.body.classList.remove("hide-mobile-modal");
      }
      if (reason == undefined) {
        this.activeModal.dismiss();
      }
    });
  }

  transferTpken(param, phone_number) {
    const params = {
      'phone_number': phone_number
    };

    this.spinner.show();
    this._walletService.getOTP().subscribe(
      (response: any) => {
        this.spinner.hide();
        if (response.success) {
          this.closeDialog();
          this.openOtpModal(param, phone_number);
        }
        else if(response.message) {
          const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modalRef.componentInstance.message = response.message === 'Authenticate'? 'Sorry,Something went wrong. Please try again after some time.':response.message;
        } else if(response.errors){
          const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modalRef.componentInstance.message = response.errors;
        }
      });
  }

  openOtpModal(giftData, phone_number) {
    const modalRef = this.modalService.open(EnterOtpComponent, { centered: true });
    modalRef.componentInstance.giftUserData = giftData;
    modalRef.componentInstance.phone_number = { phone_number: phone_number };
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
